import { createReducer } from '@reduxjs/toolkit';
import { setStartedFrom } from './actions';
import { MetaState } from './types';

const initialState: MetaState = { startedFrom: undefined };

export const metaReducer = createReducer<MetaState>(initialState, (builder) => {
    builder.addCase(setStartedFrom, (draft, action) => {
        draft.startedFrom = action.payload;
    });
});
